<template>
    <div class="popup" :class="classObj" @click="showTypeList = false">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <div class="header">
                <div>{{ $t("RedemptionCode.RedemptionRecord") }}</div>
                <div class="close">
                    <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                </div>
            </div>
            <div class="content">
                <div class="list_content">
                    <van-list v-model="isLoading" :finished="!hasMore" :loading-text="$t('home.loading')"
                        @load="getInfo" class="list_box" offset="50" :immediate-check=false v-if="list.length">
                        <div class="list" v-if="list.length">
                            <div class="list_item" v-for="(item, index) in list" :key="index">
                                <div class="time">{{ item.drawTime }}</div>
                                <div class="amount">+{{ CurrencyType }}{{ item.drawAmt }}</div>
                            </div>
                        </div>
                        <div v-if="!hasMore && !isLoading && list.length" class="loading">
                            {{ $t("lang.NoMore") }}
                        </div>
                    </van-list>
                    <div class="empty" v-else>
                        <img src="@/assets/common/empty.png" alt="" class="empty_img">
                        <div>{{ $t("lang.NoData") }}</div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { getDrawRecord } from '@/api/bonusCenter'
import { mapState } from 'vuex'
export default {
    name: 'RedemptionRecordPopup',
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        }
    },
    data() {
        return {
            show: false,
            list: [],
            pageNo: 0,
            hasMore: true,
            isLoading: false,
            typeAct: 0,
            range: '',
            firstLoaded: true,
            isClose: true
        }
    },
    created() { },
    methods: {
        open() {
            this.show = true
            if (this.firstLoaded) {
                this.list = []
                this.pageNo = 0
                this.hasMore = true
                this.isLoading = false
                this.getInfo()
            }
        },
        close() {
            this.show = false
        },
        getInfo() {
            if (!this.hasMore) return
            if (this.isLoading) return
            this.isLoading = true
            this.pageNo++
            const params = {
                pageNo: this.pageNo,
                pageSize: 20
            }
            getDrawRecord(params).then((res) => {
                if (!res || res.code) return
                const D = res.result
                this.list = this.list.concat(D.records)
                this.hasMore = D.total > this.list.length
                this.firstLoaded = false
                this.isLoading = false
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    text-align: left;
    position: relative;

    &.mobile {
        .van-popup {
            &.van-popup--center {
                top: 0;
                left: 0;
                transform: translate3d(0, 0, 0);
                width: 100% !important;
                height: 100% !important;
                display: flex;
                flex-direction: column;
                padding-bottom: .1rem;
            }

            .content {
                // padding: .3rem;

                .list_content {

                    .top {
                        font-size: .24rem;
                    }

                    .list {

                        .list_item {
                            font-size: .26rem;
                            height: 1rem;
                            line-height: .28rem;
                        }
                    }

                    .loading {
                        font-size: .24rem;
                        margin-top: .2rem;
                    }

                    .empty {
                        font-size: .32rem;

                        .empty_img {
                            width: 3.4rem;
                        }
                    }
                }
            }
        }
    }

    .van-popup {
        width: 500px;
        height: 700px;
        overflow: visible;
        background: $bg-popup-color !important;
        border-radius: .24rem;

        .header {
            width: 100%;
            height: 1.2rem;
            font-size: .36rem;
            color: #fff;
            line-height: 1.2rem;
            position: relative;
            left: 50%;
            top: 0;
            transform: translateX(-50%);
            font-weight: bold;
            text-align: center;

            .close {
                position: absolute;
                top: 0;
                right: .2rem;
                color: #f0c87c;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.3s;

                i {
                    font-size: 20px;
                }

                &:hover {
                    color: #ffffff;
                    rotate: -180deg;
                }
            }
        }

        .content {
            height: calc(100% - 1.2rem);
            display: flex;
            flex-direction: column;
            padding: 0 .2rem .24rem;
            box-sizing: border-box;

            .list_content {
                flex: 1;
                position: relative;
                border-radius: .24rem;
                background: $bg-box-color;

                .list_box {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    overflow-y: auto;
                    padding: .18rem;
                }

                .top {
                    display: flex;
                    align-items: center;
                    height: 1.14rem;
                    color: #d8b97f;
                    font-size: 14px;

                    >div {
                        flex: 1;
                        text-align: center;
                    }
                }

                .list {

                    .list_item {
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        font-size: .2rem;
                        color: $font-sub-color;
                        padding: .2rem;
                        border-radius: .1rem;
                        position: relative;
                        row-gap: .02rem;

                        .time{
                            color: rgba(255,255,255,.8);
                        }

                        .amount{
                            color: #fff;
                            font-size: .28rem;
                        }
                    }
                }

                .loading {
                    color: $font-sub-color;
                    font-size: 12px;
                    text-align: center;
                    margin-top: 10px;
                }

                .empty {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    color: $font-sub-color;
                    font-size: 16px;
                    text-align: center;

                    .empty_img {
                        width: 170px;
                        object-fit: contain;
                    }
                }
            }
        }
    }
}
</style>
